<template>
  <div>
    <div class="overlay" v-if="overlayStatus" @click="closeOverlay"></div>
    <div id="default-layout">
      <Navbar ref="navbar" @closeOverlay="closeOverlay" @activateOverlay="activateOverlay" />
      <div class="main-wrapper">
        <div class="slot-wrapper" :style="{ 'margin-bottom': $route.name === 'PaymentDetail' && '170px'}">
          <slot id="view-router"
            @triggerLoginModal="triggerLoginModal"
            @toggleSearch="openInputSearch"
            @triggerEmailVerificationModal="triggerEmailVerificationModal"
          />
        </div>
        <Footer />
        <!-- <float-action-button></float-action-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/navbar/Navbar'
import Footer from '../components/Footer'
// import FloatActionButton from '../components/tanyamu/FloatActionButton'

export default {
  components: {
    Navbar,
    Footer
    // FloatActionButton
  },
  data: () => ({
    overlayStatus: false
  }),
  methods: {
    triggerLoginModal () {
      this.$refs.navbar.toggleMasuk()
    },
    openInputSearch () {
      this.$refs.navbar.toggleSearchMobile()
    },
    triggerEmailVerificationModal () {
      this.$refs.navbar.toggleEmailVerification()
    },
    searchNavbar (value) {
      this.$refs.navbar.searchNavbar(value)
    },
    activateOverlay (value) {
      this.overlayStatus = value
    },
    closeOverlay () {
      this.overlayStatus = false
      this.$store.commit('discovery/SET_IS_OPEN_NAVBAR_RECOMMENDATION', false)
    },
    openModalRegisterOAuthForm2 () {
      this.$refs.navbar.openModalRegisterOAuthForm2()
    },
    openModalRegisterForm2 () {
      this.$refs.navbar.openModalRegisterForm2()
    }
  },
  mounted () {
    this.$store.commit('SET_ENV_BELAJAR')
    this.$store.commit('SET_ACTIVE_ENVIRONMENT')
    this.$store.dispatch('subnavbar/initMenuList')
    let sociomile = document.getElementsByClassName('custom_widget')[0]
    if (sociomile) {
      sociomile.style.display = 'inherit'
    }
    // let hubSpotFrame = document.getElementById('hubspot-messages-iframe-container')
    // if(hubSpotFrame !== null || hubSpotFrame !== undefined){
    //   let newData = document.getElementById('hubspot-messages-iframe-container')
    //   newData.style.display = 'absolute'
    //   newData.style.width = '100px'
    //   newData.style.height = '96px'
    // }
  }
}
</script>

<style scoped>
a{
  text-decoration: none;
  color: inherit;
}
#default-layout {
  font-family: "Open Sans", sans-serif;
  /* height: 100%; */
}
.main-wrapper{
  height: 100%;
  background-color: var(--color-neutral-400);
}
.slot-wrapper{
  /* min-height: 100vh; */
  min-height: calc(100vh - 224px - 54px);
}

.overlay {
  position: fixed;
  width: 100%;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5); /*dim the background*/
  min-height: 100%;
}

@media screen and (max-width: 1023px) {
  /* hide footer on mobile for parent component with class 'hide-footer-on-mobile' */
  .slot-wrapper:has(> div.hide-footer-on-mobile) + .footer {
    display: none;
  }
}
</style>
